import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('menusection');

const DEFAULTS = {
  DIVIDER_VARIANT: 'solid',
} as const;

export { TAG_NAME, DEFAULTS };
